module.exports = __webpack_public_path__ + "static/media/IMG_5773.0f3a5caf.jpg";